import { createContext } from 'react';

// PROJECT CONFIG //

export const MEDIA_URL = createContext(process.env.REACT_APP_MEDIA_URL);
export const API_URL = createContext(process.env.REACT_APP_API_URL);
export const AUTH_TOKEN = createContext('');
